module.exports = __webpack_public_path__ + "static/media/wk-hidden.b2a9ca36.svg";